import * as angular from "angular";
import {IController} from "angular";

export class shippersTableCtrl implements IController {

  infiniteScroll: any;
  isShipperLoginsView: boolean;
  enableRemove: boolean;
  enableActivateDeactivate: boolean;
  onDelete: Function;
  onActivateOrDeactivateShipper: Function;


  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.shippers')
  .component('shippersTable', {
    bindings: {
      infiniteScroll: '=',
      isShipperLoginsView: '<',
      enableRemove: '<?',
      enableActivateDeactivate: '<?',
      onActivateOrDeactivateShipper: '&',
      onDelete: '&'
    },
    template: require('./shippers-table.html').default,
    controller: shippersTableCtrl
  });
